import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";

// Check if key is configured, otherwise use a mock client
export const bugsnagClient = process.env.MIX_BUGSNAG_API_KEY
  ? Bugsnag.start({
      apiKey: process.env.MIX_BUGSNAG_API_KEY,
      plugins: [new BugsnagPluginReact(React)],
      beforeSend: report => {
        if (report.errorMessage === "Network Error") {
          report.ignore();
        }
      },
    })
  : {
      notify: message => {
        console.debug("mock: Bugsnag notified", message);
      },
      getPlugin: () => ({ children }) => children,
      leaveBreadcrumb(message, metadata, type) {
        console.debug(
          `mock: Bugsnag breadcrumb: ${type}: ${message}`,
          metadata
        );
      },
    };

export const notifyError = error => {
  bugsnagClient.notify(error, {
    beforeSend: report => {
      report.updateMetaData("error", error);
      if (error.resonse) {
        report.updateMetaData("response", error.response || "");
      }
    },
  });
};

export const ErrorBoundary = bugsnagClient.getPlugin("react");
